import React, { Component, Fragment } from "react";
import { Redirect } from "react-router-dom";
import "./editprofile.css";
import "../accounts/register/register.css";
import {
  Modal,
  Form,
  Icon,
  Input,
  Checkbox,
  Tooltip,
  Cascader,
  Select,
  Row,
  Col,
  Button,
  AutoComplete,
  Card,
  Avatar,
  Upload
} from "antd";
import profileimg from "../../style/images/home/profile dropdown/profile pic.png";
import button from "../../style/images/home/profile dropdown/change btn.png";
import Savebutton from "../../style/images/home/profile dropdown/save changes btn.png";
import Header from "../header/header";
import Footer from "../footer/footer";

const contries = [
  {
    value: "Pakistan",
    label: "Pakistan"
  },
  {
    value: "Afganistan",
    label: "Afganistan"
  }
];

export default class EditProfileForm extends Component {
  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log("Received values of form: ", values);
      }
    });
  };
  changeimage() {
    console.log("image changing");
  }
  handleReset() {
    this.props.form.resetFields();
  }
  normFile = e => {
    console.log("Upload event:", e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Fragment>
        <Header {...this.props} />
        <Card title="Edit Profile" style={{ textAlign: "left" }} headStyle={{padding:"0"}}>

          <div style={{ padding: "3%" }}>
            <Form onSubmit={this.handleSubmit} className="register">
              <Form.Item>
                <Avatar size={100} src={profileimg} />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {getFieldDecorator("upload", {
                  valuePropName: "fileList",
                  getValueFromEvent: this.normFile
                })(
                  <Upload
                    name="logo"
                    //  action="/upload.do"
                  >
                    <img
                      className="avatar"
                      src={button}
                      onClick={() => this.changeimage()}
                    />
                  </Upload>
                )}
              </Form.Item>

              <div className="row">
                <div className="col-md-6">
                  <Form.Item label="COUNTRY">
                    {getFieldDecorator("countries", {
                      initialValue: ["Pakistan"],
                      rules: [
                        {
                          type: "array",
                          required: true,
                          message: "Please select your country!"
                        }
                      ]
                    })(
                      <Cascader
                        style={{ backgroundColor: "#343d66", color: "white" }}
                        options={contries}
                      />
                    )}
                  </Form.Item>
                </div>
                <div className="col-md-6">
                  <Form.Item label="EMAIL">
                    {getFieldDecorator("email", {
                      rules: [
                        { required: true, message: "Please input your Email!" }
                      ]
                    })(
                      <Input
                        style={{ color: "white" }}
                        // prefix={
                        //   <Icon
                        //     type="user"
                        //     style={{ color: "rgba(0,0,0,.25)" }}
                        //   />
                        // }
                        type="Email"
                        placeholder="Email"
                      />
                    )}
                  </Form.Item>
                </div>
              </div>

              <div className="row">
                <div className="col-md-3 col-xs-6">
                  <Form.Item label="REAL NAME">
                    {getFieldDecorator("firstName", {
                      rules: [
                        {
                          required: true,
                          message: "Please input your First Name!"
                        }
                      ]
                    })(
                      <Input
                        style={{ color: "white" }}
                        // prefix={
                        //   <Icon
                        //     type="user"
                        //     style={{ color: "rgba(0,0,0,.25)" }}
                        //   />
                        // }
                        placeholder="First Name"
                      />
                    )}
                  </Form.Item>
                </div>
                <div className="col-md-3 col-xs-6">
                  <Form.Item label=" " colon={false} required={false}>
                    {getFieldDecorator("lastName", {
                      rules: [
                        {
                          required: true,
                          message: "Please input your Last Name!"
                        }
                      ]
                    })(
                      <Input
                        style={{ color: "white" }}
                        // prefix={
                        //   <Icon
                        //     type="user"
                        //     style={{ color: "rgba(0,0,0,.25)" }}
                        //   />
                        // }
                        placeholder="Last Name"
                      />
                    )}
                  </Form.Item>
                </div>
                <div className="col-md-6">
                  <Form.Item label="MOBILE NUMBER">
                    {getFieldDecorator("mobileNumber", {
                      rules: [
                        {
                          required: true,
                          message: "Please input your Mobile Number!"
                        }
                      ]
                    })(
                      <Input
                        style={{ color: "white" }}
                        // prefix={
                        //   <Icon
                        //     type="user"
                        //     style={{ color: "rgba(0,0,0,.25)" }}
                        //   />
                        // }
                        type="Number"
                        placeholder="Mobile Number"
                      />
                    )}
                  </Form.Item>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <Form.Item label="DISPLAY NAME">
                    {getFieldDecorator("displayName", {
                      rules: [
                        {
                          required: true,
                          message: "Please input your Display Name!"
                        }
                      ]
                    })(
                      <Input
                        style={{ color: "white" }}
                        // prefix={
                        //   <Icon
                        //     type="user"
                        //     style={{ color: "rgba(0,0,0,.25)" }}
                        //   />
                        // }
                        placeholder=" Display Name"
                      />
                    )}
                  </Form.Item>
                </div>
                <div className="col-md-6">
                  <Form.Item label="ADDRESS">
                    {getFieldDecorator("address", {
                      rules: [
                        {
                          required: true,
                          message: "Please input your address  !"
                        }
                      ]
                    })(
                      <Input
                        style={{ color: "white" }}
                        // prefix={
                        //   <Icon
                        //     type="user"
                        //     style={{ color: "rgba(0,0,0,.25)" }}
                        //   />
                        // }
                        placeholder=" Address"
                      />
                    )}
                  </Form.Item>
                </div>
              </div>
              <Form.Item>
                <div className="row">
                  <div className="col-md-6">
                    <p style={{ color: "white" }}>
                      Something's wrong?{" "}
                      <a className ="underline"onClick={() => this.handleReset()}><b>DISCARD CHANGES</b></a>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <Button
                      style={{
                        color: "transparent",
                        display: "contents"
                      }}
                      type="image"
                      htmlType="submit"
                    >
                      <img
                        style={{
                          float: "right"
                        }}
                        src={Savebutton}
                      />
                    </Button>
                  </div>
                </div>
              </Form.Item>
            </Form>
          </div>
        </Card>

        <Footer />
      </Fragment>
    );
  }
}
export const EditProfile = Form.create({ name: "edit_profile" })(
  EditProfileForm
);
